import { BranchInfo } from "../../Models";
import { isVirtualBranch } from "../../helpers";
import { urlFormatter } from "sb-resp-utils";
export class BranchesParser {
    constructor() { }
    parseData(sport) {
        return new BranchInfo(this.prepareData(sport));
    }
    prepareData(sport) {
        const id = sport.id ? parseInt(sport.id) : 0;
        const rankId = sport.order ? sport.order : 0;
        const liveFixturesTotalCount = sport.liveFixturesTotalCount ? sport.liveFixturesTotalCount : 0;
        const sportName = sport.name ? sport.name : "";
        return {
            ID: id,
            Name: sportName,
            RankID: rankId,
            SortID: rankId,
            Code: urlFormatter.getSportUrl(sportName),
            MasterEvents: [],
            EventNames: ["1x2", "Spread", "Over/Under"],
            TotalLiveCount: liveFixturesTotalCount,
            IsVirtualSport: isVirtualBranch(id),
            Visible: true,
            AllLiveVisible: false,
            hasLiveEvents: liveFixturesTotalCount !== 0
        };
    }
}
//# sourceMappingURL=BranchesParser.js.map